if(!customElements.get('related-articles')) {
  class RelatedArticles extends HTMLElement {
    constructor() {
      super();

      this.carouselMode = this.dataset.carouselMode;
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.carouselCenteredTablet = this.dataset.carouselCenteredTablet;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;
      
      this.blogUrl = this.dataset.blogUrl;
      this.articleTags = JSON.parse(this.dataset.articleTags);
      this.articleTags = this.articleTags.map(function(tag) {return $s.handleize(tag);});
      if (this.dataset.tagsAllowed) {
        this.tagsAllowed = JSON.parse(this.dataset.tagsAllowed);
        if (this.tagsAllowed.length > 0) {
          //array intersection
          let tags = this.tagsAllowed.map(function(tag) {return $s.handleize(tag);});
          this.articleTags = this.articleTags.filter(function(n) {return tags.indexOf(n) !== -1;});        
        }
      }

      if(this.dataset.customPlacement){
        document.querySelector("#related-articles").appendChild(this);
      }

      this.articleId = this.dataset.articleId;
      this.itemsLimit = parseInt(this.dataset.itemsLimit);
      this.blogTemplate = this.dataset.blogTemplate;
      this.loadItems();
    }

    loadItems() {
      var articleId = this.articleId;
      var self = this;
      var url = this.blogUrl;
      var articlesIds = [];
      var articles = [];
      var waiting = 0;
      var itemsLimit = this.itemsLimit;
      var articleTags = this.articleTags;
      var tagsQueries = [];
      var parser = new DOMParser();
      for (var i=0; i<articleTags.length; i++) {
        tagsQueries.push(articleTags.slice(0, articleTags.length - i));
      }
      if (tagsQueries.length>3) {
        tagsQueries.splice(2, tagsQueries.length-3);
      }
      for (var i=0; i<tagsQueries.length; i++) {
        var tags = tagsQueries[i].join('+');
        waiting++;
        $s.get({
          url: url + '/tagged/'+tags+'?view=' + this.blogTemplate,
          cache: false,
          success: function(data){
            var items = data.split('<!-- article separator -->');
            items.forEach(function(item) {
              var doc = parser.parseFromString(item, 'text/html');
              var element = doc.querySelector('.article-item');
              articles.push(element);
            })
          },
          error: function(){
            // No articles found with these tags. 404 error.
          },
          always: function() {
            waiting--;
            if(waiting == 0){
              
              articles.sort(function(obj1, obj2) {
                var obj1TagsFilter = obj1.dataset.tagsfilter.split(',');
                var obj2TagsFilter = obj2.dataset.tagsfilter.split(',');
                if (obj1TagsFilter.length==obj2TagsFilter.length)
                  return obj2.dataset.publishedDate > obj1.dataset.publishedDate ? 1 : -1;
                else
                  return obj2TagsFilter.length > obj1TagsFilter.length ? 1 : -1;
              });
              var idsShown = {};
              var shown = 0;
              articles.forEach(function(item,i ) {
                if(shown < itemsLimit && item.dataset.articleId != articleId){
                  if (!(idsShown[item.dataset.articleId])) {
                    self.querySelector(".articles-wrapper").insertAdjacentElement('beforeend', item);
                    idsShown[item.dataset.articleId] = item;
                    shown++;
                  }
                }
              });
              if (articles.length <= 3) {
                const arrows = document.querySelector('.featured-articles');
                arrows.classList.add('remove-arrows');
              }
              if (shown>0) {
                if(self.dataset.customPlacement){
                  document.querySelector("#related-articles").closest('.related-articles').classList.remove('hide')
                }
                self.classList.remove('hide');

                // keen slide this if needed => self.querySelector(".articles-wrapper");
                self.initSlider();

                var layoutTId = 0;
                var lastWidth = null;
                function layout() {
                  if (lastWidth != window.innerWidth) {
                    lastWidth = window.innerWidth;
                    clearTimeout(layoutTId);
                    layoutTId = setTimeout(function() {
                      if (window.innerWidth>900) {
                        $s.matchHeight(self.querySelectorAll(".articles-wrapper .title"));
                      } else {
                        self.querySelectorAll(".articles-wrapper .title").forEach(function(item){
                          item.style.minHeight = '';
                        });
                      }
                    }, 300);
                  }
                }
                window.addEventListener('resize', layout);
                layout();
                
              }
            }
          }
        }) //end $s.get
      } //end for loop
    }
    initSlider() {
      var self = this;
      
      this.sliderObj = new KeenSlider(self.querySelector(".articles-wrapper"), {
        mode: self.carouselMode,
        loop: self.carouselLoop=="true",
        dots: self.querySelector('.keen-dots'),
        prevButton: self.querySelector('.keen-arrow.prev'),
        nextButton: self.querySelector('.keen-arrow.next'),
        autoplay: self.carouselAutoplay,
        breakpoints: {
          '(min-width: 901px)': {
            centered: self.carouselCenteredDesktop=="true",
            spacing: self.carouselSpacingDesktop,
            slidesPerView: self.slidesPerViewDesktop
          },
          '(min-width: 601px) and (max-width: 900px)': {
            centered: self.carouselCenteredTablet=="true",
            spacing: self.carouselSpacingTablet,
            slidesPerView: self.slidesPerViewTablet
          },
          '(max-width: 600px)': {
            centered: self.carouselCenteredMobile=="true",
            spacing: self.carouselSpacingMobile,
            slidesPerView: self.slidesPerViewMobile
          }
        }
      });
    }
  }
  customElements.define('related-articles', RelatedArticles);
}